import { render } from "./RatingRageSelector.vue?vue&type=template&id=32dad33f"
import script from "./RatingRageSelector.vue?vue&type=script&lang=js"
export * from "./RatingRageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__